export default theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(1),
        margin: theme.spacing(1, 'auto'),
        padding: theme.spacing(1.5),
        width: 'fit-content',
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.spacing(0.5),
    },
    icon: {
        fontSize: '0.875rem',
        color: theme.palette.primary.main,
    },
    text: {
        color: theme.palette.text.secondary,
    },
});
